const MobileContacts = () => {
  const onClick = () => {
    trigger.classList.toggle('close-menu');
    menu.classList.toggle('transition-menu');
  };

  const menu = document.getElementById('call-mob-menu');
  const trigger = document.getElementById('call-mob');
  trigger.addEventListener('click', onClick);
};

export default MobileContacts;
